// import WebOfficeSDK from '../wps/web-office-sdk-v1.1.19.es.js';
/**
 * 在线打开
 * @param {*} url 文件url 
 * @param {*} className 挂载
 * @param {*} token 鉴权
 */
function see({
	url,
	className,
	token
}) {
	const jssdk = WebOfficeSDK.config({
		url,
		mount: document.querySelector(className),
		mode:'normal'
	});
	jssdk.setToken({
		token: token,
		timeout: 10 * 60 * 1000,
	});
	// 文件打开成功或者失败时的事件回调
	jssdk.on('fileOpen', (data) => {
		console.log('文件打开：', data);
	});
	jssdk.on('error', (err) => {
		console.log('发生错误：', err);
	});

}
export default {
	see
}



// WEBPACK FOOTER //
// ./static/js/function/wps.js